import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import "./styles/_hero.scss"

interface HeroProps extends WithClassName {
  headline?: React.ReactNode
  text?: React.ReactNode
  image?: React.ReactNode
  buttons?: React.ReactNode | React.ReactNode[]
  objectFit?: string | null | undefined
}

export const Hero = React.memo(
  ({ headline, text, buttons, image, className, objectFit }: HeroProps) => {
    return (
      <section className={classNames("hero", `hero--v2`, objectFit, className)}>
        <div className="hero__content">
          {headline ? <div className="hero__headline">{headline}</div> : null}
          {text ? <div className="hero__paragraph">{text}</div> : null}
          {buttons ? <div className="hero__cta">{buttons}</div> : null}
        </div>
        {image ? <div className="hero__image">{image}</div> : null}
      </section>
    )
  }
)
